"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: credit-report/credit-report-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fcredit-report%2Fcredit-report-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreditReportServiceClient = exports.creditReportProgressStatusToJSON = exports.creditReportProgressStatusFromJSON = exports.GetUserCreditSummaryResponse = exports.GetUserCreditSummaryRequest = exports.GetAccountCreditStatusResponse = exports.GetAccountCreditStatusRequest = exports.CreditInsightData = exports.UserCreditDetails = exports.CreditReportProgress = exports.CreditReportProgressSummary = exports.AccountCreditDetails = exports.GetDetailedCreditReportResponse = exports.GetDetailedCreditReportRequest = exports.GetUserCreditStatusResponse = exports.GetUserCreditStatusRequest = exports.CreditReportProgressStatus = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const account_credit_status_1 = require("./account-credit-status");
const credit_report_requirements_1 = require("./credit-report-requirements");
const detailed_report_1 = require("./detailed-report");
const insight_1 = require("./insight");
const user_credit_summary_1 = require("./user-credit-summary");
const protobufPackage = 'com.step.creditreport.proto';
var CreditReportProgressStatus;
(function (CreditReportProgressStatus) {
    CreditReportProgressStatus["INVALID_SCORE_PHASE_STATUS"] = "INVALID_SCORE_PHASE_STATUS";
    CreditReportProgressStatus["PENDING"] = "PENDING";
    CreditReportProgressStatus["COMPLETE"] = "COMPLETE";
    CreditReportProgressStatus["DELAYED"] = "DELAYED";
    CreditReportProgressStatus["ERROR"] = "ERROR";
    CreditReportProgressStatus["UNRECOGNIZED"] = "UNRECOGNIZED";
})(CreditReportProgressStatus || (exports.CreditReportProgressStatus = CreditReportProgressStatus = {}));
function createBaseGetUserCreditStatusRequest() {
    return {};
}
exports.GetUserCreditStatusRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetUserCreditStatusRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseGetUserCreditStatusRequest();
        return message;
    },
};
function createBaseGetUserCreditStatusResponse() {
    return {
        accountDetails: [],
        creditInsightData: exports.CreditInsightData.fromPartial({}),
        userCreditDetails: undefined,
        receiveFirstScoreProgress: undefined,
    };
}
exports.GetUserCreditStatusResponse = {
    fromJSON(object) {
        const message = {
            creditInsightData: isSet(object.creditInsightData)
                ? exports.CreditInsightData.fromJSON(object.creditInsightData)
                : exports.CreditInsightData.fromPartial({}),
        };
        if (globalThis.Array.isArray(object?.accountDetails)) {
            message.accountDetails = object.accountDetails.map((e) => exports.AccountCreditDetails.fromJSON(e));
        }
        if (isSet(object.userCreditDetails)) {
            message.userCreditDetails = exports.UserCreditDetails.fromJSON(object.userCreditDetails);
        }
        if (isSet(object.receiveFirstScoreProgress)) {
            message.receiveFirstScoreProgress = exports.CreditReportProgressSummary.fromJSON(object.receiveFirstScoreProgress);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.accountDetails?.length) {
            obj.accountDetails = message.accountDetails.map((e) => exports.AccountCreditDetails.toJSON(e));
        }
        if (message.creditInsightData !== undefined) {
            obj.creditInsightData = exports.CreditInsightData.toJSON(message.creditInsightData);
        }
        if (message.userCreditDetails !== undefined) {
            obj.userCreditDetails = exports.UserCreditDetails.toJSON(message.userCreditDetails);
        }
        if (message.receiveFirstScoreProgress !== undefined) {
            obj.receiveFirstScoreProgress = exports.CreditReportProgressSummary.toJSON(message.receiveFirstScoreProgress);
        }
        return obj;
    },
    create(base) {
        return exports.GetUserCreditStatusResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetUserCreditStatusResponse();
        message.accountDetails =
            object.accountDetails?.map((e) => exports.AccountCreditDetails.fromPartial(e)) || [];
        message.creditInsightData =
            (object.creditInsightData !== undefined && object.creditInsightData !== null)
                ? exports.CreditInsightData.fromPartial(object.creditInsightData)
                : exports.CreditInsightData.fromPartial({});
        message.userCreditDetails =
            (object.userCreditDetails !== undefined && object.userCreditDetails !== null)
                ? exports.UserCreditDetails.fromPartial(object.userCreditDetails)
                : undefined;
        message.receiveFirstScoreProgress =
            (object.receiveFirstScoreProgress !== undefined && object.receiveFirstScoreProgress !== null)
                ? exports.CreditReportProgressSummary.fromPartial(object.receiveFirstScoreProgress)
                : undefined;
        return message;
    },
};
function createBaseGetDetailedCreditReportRequest() {
    return { reportId: '' };
}
exports.GetDetailedCreditReportRequest = {
    fromJSON(object) {
        const message = {
            reportId: isSet(object.reportId) ? globalThis.String(object.reportId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.reportId !== '') {
            obj.reportId = message.reportId;
        }
        return obj;
    },
    create(base) {
        return exports.GetDetailedCreditReportRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetDetailedCreditReportRequest();
        message.reportId = object.reportId ?? '';
        return message;
    },
};
function createBaseGetDetailedCreditReportResponse() {
    return { report: detailed_report_1.DetailedReport.fromPartial({}) };
}
exports.GetDetailedCreditReportResponse = {
    fromJSON(object) {
        const message = {
            report: isSet(object.report)
                ? detailed_report_1.DetailedReport.fromJSON(object.report)
                : detailed_report_1.DetailedReport.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.report !== undefined) {
            obj.report = detailed_report_1.DetailedReport.toJSON(message.report);
        }
        return obj;
    },
    create(base) {
        return exports.GetDetailedCreditReportResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetDetailedCreditReportResponse();
        message.report = (object.report !== undefined && object.report !== null)
            ? detailed_report_1.DetailedReport.fromPartial(object.report)
            : detailed_report_1.DetailedReport.fromPartial({});
        return message;
    },
};
function createBaseAccountCreditDetails() {
    return {
        accountId: '',
        creditStatus: account_credit_status_1.AccountCreditStatus.fromPartial({}),
        reportingRequirements: credit_report_requirements_1.ReportingRequirements.fromPartial({}),
    };
}
exports.AccountCreditDetails = {
    fromJSON(object) {
        const message = {
            accountId: isSet(object.accountId) ? globalThis.String(object.accountId) : '',
            creditStatus: isSet(object.creditStatus)
                ? account_credit_status_1.AccountCreditStatus.fromJSON(object.creditStatus)
                : account_credit_status_1.AccountCreditStatus.fromPartial({}),
            reportingRequirements: isSet(object.reportingRequirements)
                ? credit_report_requirements_1.ReportingRequirements.fromJSON(object.reportingRequirements)
                : credit_report_requirements_1.ReportingRequirements.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.accountId !== '') {
            obj.accountId = message.accountId;
        }
        if (message.creditStatus !== undefined) {
            obj.creditStatus = account_credit_status_1.AccountCreditStatus.toJSON(message.creditStatus);
        }
        if (message.reportingRequirements !== undefined) {
            obj.reportingRequirements = credit_report_requirements_1.ReportingRequirements.toJSON(message.reportingRequirements);
        }
        return obj;
    },
    create(base) {
        return exports.AccountCreditDetails.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAccountCreditDetails();
        message.accountId = object.accountId ?? '';
        message.creditStatus = (object.creditStatus !== undefined && object.creditStatus !== null)
            ? account_credit_status_1.AccountCreditStatus.fromPartial(object.creditStatus)
            : account_credit_status_1.AccountCreditStatus.fromPartial({});
        message.reportingRequirements =
            (object.reportingRequirements !== undefined && object.reportingRequirements !== null)
                ? credit_report_requirements_1.ReportingRequirements.fromPartial(object.reportingRequirements)
                : credit_report_requirements_1.ReportingRequirements.fromPartial({});
        return message;
    },
};
function createBaseCreditReportProgressSummary() {
    return {
        reportCreated: exports.CreditReportProgress.fromPartial({}),
        reportSent: exports.CreditReportProgress.fromPartial({}),
        receiveScore: exports.CreditReportProgress.fromPartial({}),
    };
}
exports.CreditReportProgressSummary = {
    fromJSON(object) {
        const message = {
            reportCreated: isSet(object.reportCreated)
                ? exports.CreditReportProgress.fromJSON(object.reportCreated)
                : exports.CreditReportProgress.fromPartial({}),
            reportSent: isSet(object.reportSent)
                ? exports.CreditReportProgress.fromJSON(object.reportSent)
                : exports.CreditReportProgress.fromPartial({}),
            receiveScore: isSet(object.receiveScore)
                ? exports.CreditReportProgress.fromJSON(object.receiveScore)
                : exports.CreditReportProgress.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.reportCreated !== undefined) {
            obj.reportCreated = exports.CreditReportProgress.toJSON(message.reportCreated);
        }
        if (message.reportSent !== undefined) {
            obj.reportSent = exports.CreditReportProgress.toJSON(message.reportSent);
        }
        if (message.receiveScore !== undefined) {
            obj.receiveScore = exports.CreditReportProgress.toJSON(message.receiveScore);
        }
        return obj;
    },
    create(base) {
        return exports.CreditReportProgressSummary.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCreditReportProgressSummary();
        message.reportCreated = (object.reportCreated !== undefined && object.reportCreated !== null)
            ? exports.CreditReportProgress.fromPartial(object.reportCreated)
            : exports.CreditReportProgress.fromPartial({});
        message.reportSent = (object.reportSent !== undefined && object.reportSent !== null)
            ? exports.CreditReportProgress.fromPartial(object.reportSent)
            : exports.CreditReportProgress.fromPartial({});
        message.receiveScore = (object.receiveScore !== undefined && object.receiveScore !== null)
            ? exports.CreditReportProgress.fromPartial(object.receiveScore)
            : exports.CreditReportProgress.fromPartial({});
        return message;
    },
};
function createBaseCreditReportProgress() {
    return { etaMs: '0', status: CreditReportProgressStatus.INVALID_SCORE_PHASE_STATUS };
}
exports.CreditReportProgress = {
    fromJSON(object) {
        const message = {
            etaMs: isSet(object.etaMs) ? globalThis.String(object.etaMs) : '0',
            status: isSet(object.status)
                ? creditReportProgressStatusFromJSON(object.status)
                : CreditReportProgressStatus.INVALID_SCORE_PHASE_STATUS,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.etaMs !== '0') {
            obj.etaMs = message.etaMs;
        }
        if (message.status !== CreditReportProgressStatus.INVALID_SCORE_PHASE_STATUS) {
            obj.status = creditReportProgressStatusToJSON(message.status);
        }
        return obj;
    },
    create(base) {
        return exports.CreditReportProgress.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCreditReportProgress();
        message.etaMs = object.etaMs ?? '0';
        message.status = object.status ?? CreditReportProgressStatus.INVALID_SCORE_PHASE_STATUS;
        return message;
    },
};
function createBaseUserCreditDetails() {
    return { creditReportEnrolledAtMs: '0' };
}
exports.UserCreditDetails = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.creditReportEnrolledAtMs)) {
            message.creditReportEnrolledAtMs = globalThis.String(object.creditReportEnrolledAtMs);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.creditReportEnrolledAtMs !== undefined && message.creditReportEnrolledAtMs !== '0') {
            obj.creditReportEnrolledAtMs = message.creditReportEnrolledAtMs;
        }
        return obj;
    },
    create(base) {
        return exports.UserCreditDetails.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUserCreditDetails();
        message.creditReportEnrolledAtMs = object.creditReportEnrolledAtMs ?? '0';
        return message;
    },
};
function createBaseCreditInsightData() {
    return { transunion: undefined };
}
exports.CreditInsightData = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.transunion)) {
            message.transunion = insight_1.TransUnionCreditData.fromJSON(object.transunion);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.transunion !== undefined) {
            obj.transunion = insight_1.TransUnionCreditData.toJSON(message.transunion);
        }
        return obj;
    },
    create(base) {
        return exports.CreditInsightData.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCreditInsightData();
        message.transunion = (object.transunion !== undefined && object.transunion !== null)
            ? insight_1.TransUnionCreditData.fromPartial(object.transunion)
            : undefined;
        return message;
    },
};
function createBaseGetAccountCreditStatusRequest() {
    return { accountId: '' };
}
exports.GetAccountCreditStatusRequest = {
    fromJSON(object) {
        const message = {
            accountId: isSet(object.accountId) ? globalThis.String(object.accountId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.accountId !== '') {
            obj.accountId = message.accountId;
        }
        return obj;
    },
    create(base) {
        return exports.GetAccountCreditStatusRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetAccountCreditStatusRequest();
        message.accountId = object.accountId ?? '';
        return message;
    },
};
function createBaseGetAccountCreditStatusResponse() {
    return {
        creditStatus: account_credit_status_1.AccountCreditStatus.fromPartial({}),
        reportingRequirements: credit_report_requirements_1.ReportingRequirements.fromPartial({}),
    };
}
exports.GetAccountCreditStatusResponse = {
    fromJSON(object) {
        const message = {
            creditStatus: isSet(object.creditStatus)
                ? account_credit_status_1.AccountCreditStatus.fromJSON(object.creditStatus)
                : account_credit_status_1.AccountCreditStatus.fromPartial({}),
            reportingRequirements: isSet(object.reportingRequirements)
                ? credit_report_requirements_1.ReportingRequirements.fromJSON(object.reportingRequirements)
                : credit_report_requirements_1.ReportingRequirements.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.creditStatus !== undefined) {
            obj.creditStatus = account_credit_status_1.AccountCreditStatus.toJSON(message.creditStatus);
        }
        if (message.reportingRequirements !== undefined) {
            obj.reportingRequirements = credit_report_requirements_1.ReportingRequirements.toJSON(message.reportingRequirements);
        }
        return obj;
    },
    create(base) {
        return exports.GetAccountCreditStatusResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetAccountCreditStatusResponse();
        message.creditStatus = (object.creditStatus !== undefined && object.creditStatus !== null)
            ? account_credit_status_1.AccountCreditStatus.fromPartial(object.creditStatus)
            : account_credit_status_1.AccountCreditStatus.fromPartial({});
        message.reportingRequirements =
            (object.reportingRequirements !== undefined && object.reportingRequirements !== null)
                ? credit_report_requirements_1.ReportingRequirements.fromPartial(object.reportingRequirements)
                : credit_report_requirements_1.ReportingRequirements.fromPartial({});
        return message;
    },
};
function createBaseGetUserCreditSummaryRequest() {
    return {};
}
exports.GetUserCreditSummaryRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetUserCreditSummaryRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseGetUserCreditSummaryRequest();
        return message;
    },
};
function createBaseGetUserCreditSummaryResponse() {
    return { summary: user_credit_summary_1.UserCreditSummary.fromPartial({}) };
}
exports.GetUserCreditSummaryResponse = {
    fromJSON(object) {
        const message = {
            summary: isSet(object.summary)
                ? user_credit_summary_1.UserCreditSummary.fromJSON(object.summary)
                : user_credit_summary_1.UserCreditSummary.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.summary !== undefined) {
            obj.summary = user_credit_summary_1.UserCreditSummary.toJSON(message.summary);
        }
        return obj;
    },
    create(base) {
        return exports.GetUserCreditSummaryResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetUserCreditSummaryResponse();
        message.summary = (object.summary !== undefined && object.summary !== null)
            ? user_credit_summary_1.UserCreditSummary.fromPartial(object.summary)
            : user_credit_summary_1.UserCreditSummary.fromPartial({});
        return message;
    },
};
function creditReportProgressStatusFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_SCORE_PHASE_STATUS':
            return CreditReportProgressStatus.INVALID_SCORE_PHASE_STATUS;
        case 1:
        case 'PENDING':
            return CreditReportProgressStatus.PENDING;
        case 2:
        case 'COMPLETE':
            return CreditReportProgressStatus.COMPLETE;
        case 3:
        case 'DELAYED':
            return CreditReportProgressStatus.DELAYED;
        case 4:
        case 'ERROR':
            return CreditReportProgressStatus.ERROR;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return CreditReportProgressStatus.UNRECOGNIZED;
    }
}
exports.creditReportProgressStatusFromJSON = creditReportProgressStatusFromJSON;
function creditReportProgressStatusToJSON(object) {
    switch (object) {
        case CreditReportProgressStatus.INVALID_SCORE_PHASE_STATUS:
            return 'INVALID_SCORE_PHASE_STATUS';
        case CreditReportProgressStatus.PENDING:
            return 'PENDING';
        case CreditReportProgressStatus.COMPLETE:
            return 'COMPLETE';
        case CreditReportProgressStatus.DELAYED:
            return 'DELAYED';
        case CreditReportProgressStatus.ERROR:
            return 'ERROR';
        case CreditReportProgressStatus.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.creditReportProgressStatusToJSON = creditReportProgressStatusToJSON;
/**
 * Credit Report Service API
 */
class CreditReportServiceClient {
    rpc;
    name = 'com.step.creditreport.proto.CreditReportService';
    type = rpc_1.ServiceType.PUBLIC;
    path = '/credit-report';
    methods = [{
            name: 'GetAccountCreditStatus',
            requestType: exports.GetAccountCreditStatusRequest,
            responseType: exports.GetAccountCreditStatusResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetUserCreditStatus',
            requestType: exports.GetUserCreditStatusRequest,
            responseType: exports.GetUserCreditStatusResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetUserCreditSummary',
            requestType: exports.GetUserCreditSummaryRequest,
            responseType: exports.GetUserCreditSummaryResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetDetailedCreditReport',
            requestType: exports.GetDetailedCreditReportRequest,
            responseType: exports.GetDetailedCreditReportResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    /**
     * Fetch account credit status report.
     * DEPRECATED: Use GetUserCreditStatus instead.
     */
    getAccountCreditStatus(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Fetch credit status information for calling user.
     */
    getUserCreditStatus(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[1],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Gets summary information related to users credit. This endpoint returns minimal information
     * needed for app load.
     */
    getUserCreditSummary(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[2],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Fetch detailed credit monitoring report for calling user.
     */
    getDetailedCreditReport(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[3],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.CreditReportServiceClient = CreditReportServiceClient;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=credit-report-service.js.map